import {Typography, useTheme, css} from '@mui/material';
import {
  DlMuiPopper,
  enumContainer,
  GetStylesFunction,
  useMuiAnchor,
} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';
import React from 'react';

import {baseTranslateEnumFormatterParams} from 'src/js/lib/raw_rendering/base_translate_enum_formatter_params';

type Params = ICellRendererParams;

export const TranslateEnumFormatter: React.FC<Params> = (params) => {
  const enumParams = baseTranslateEnumFormatterParams(params);
  const hasTooltip = !!(enumParams.enumName && enumParams.enumValueName);

  const {mouseEventEnter, mouseEventLeave, open, anchorEl} =
    useMuiAnchor(hasTooltip);

  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <Typography variant={'value'}>
      <span
        css={styles.span}
        onMouseEnter={mouseEventEnter}
        onMouseLeave={mouseEventLeave}
      >
        <enumContainer.TranslatedEnumValue
          enumName={enumParams.enumName}
          enumValueName={enumParams.enumValueName}
        />
      </span>
      <DlMuiPopper hasTooltip={hasTooltip} anchorEl={anchorEl} open={open}>
        <Typography variant={'popper'}>
          <enumContainer.TranslatedEnumValue
            enumName={enumParams.enumName}
            enumValueName={enumParams.enumValueName}
          />
        </Typography>
      </DlMuiPopper>
    </Typography>
  );
};

const getStyles: GetStylesFunction = (options) => ({
  span: css`
    padding: ${options?.theme?.spacing(1, 0)};
  `,
});
